import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';

function CaptureImage({
  src, alt, loading = false, error = false, className = '',
}) {
  const [loadedSrc, setLoadedSrc] = useState(null);
  const [failedSrc, setFailedSrc] = useState(null);
  const failed = error || (src && failedSrc === src);
  const pending = !failed && (loading || (src && loadedSrc !== src));

  return (
    <div className="capture-image">
      {pending && (
        <Skeleton
          animation="wave"
          variant="rectangular"
          className="capture-image-skeleton"
          role="status"
          aria-label={`Loading ${alt.toLowerCase()}`}
        />
      )}
      {src && !failed && (
        <img
          src={src}
          alt={alt}
          width="100%"
          className={className}
          style={{ display: pending ? 'none' : 'block', borderRadius: '4px 4px 0 0', minHeight: 68 }}
          onLoad={() => setLoadedSrc(src)}
          onError={() => setFailedSrc(src)}
        />
      )}
      {failed && <p className="capture-image-message" role="alert">Unable to load image</p>}
    </div>
  );
}

CaptureImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  className: PropTypes.string,
};

export default CaptureImage;
